<div *ngIf="assignment" class="mx-6 my-4">
  <div class="mb-4 assignment__header">
    <div class="assignment__header__title">
      <sl-label size="large" style="--line-height--large: var(--sl-input-height-small)">
        {{assignment.contactName}}
        <sl-icon class="link" (click)="onContactClick()" name="box-arrow-up-right"></sl-icon>
      </sl-label>

      <ng-container *ngIf="assignment.action === 'None'">
        <sl-tooltip *ngIf="assignment.plan.affixment.state === 'Locked'" content="Unlock assignment" i18n-content>
          <sl-icon (click)="onUnlock()" class="assignment__header__lock" name="lock-fill"></sl-icon>
        </sl-tooltip>
        <sl-tooltip *ngIf="assignment.plan.affixment.state !== 'Locked'" content="Lock assignment" i18n-content>
          <sl-icon (click)="onLock()" class="assignment__header__lock" name="unlock-fill"></sl-icon>
        </sl-tooltip>
      </ng-container>

      <ng-container *ngIf="assignment.action !== 'None'">
        <sl-icon *ngIf="assignment.plan.affixment.state === 'Locked'" class="assignment__header__lock disabled" name="lock-fill"></sl-icon>
        <sl-icon *ngIf="assignment.plan.affixment.state !== 'Locked'" class="assignment__header__lock disabled" name="unlock-fill"></sl-icon>
      </ng-container>
    </div>

    <sl-label class="assignment__address" size="small" (click)="openMap()">
      {{assignment.address | address}}
      <sl-icon class="assignment__address__icon"  name="geo"></sl-icon>
    </sl-label>
  </div>

  <div class="grid grid-cols-4 gap-2">
    <sl-button 
      size="small" 
      (click)="onStartAssignment()" 
      [disabled]="assignment.action != 'None'" 
      i18n>Start now</sl-button>
    <sl-button size="small" (click)="onCompleteAssignment()"
      [disabled]="assignment.action != 'None' && assignment.action != 'InProgress'" i18n>Complete</sl-button>
    <sl-button size="small" (click)="onSkipAssignment()" [disabled]="assignment.action != 'None'" i18n>Skip</sl-button>
    <sl-button size="small" type="primary" (click)="onEditAssignment()" i18n>Details</sl-button>
  </div>
  <sl-menu-divider></sl-menu-divider>


  <div class="timestamp">
    <sl-label class="timestamp__time" size="small">{{assignment.plan.executionTime | date:'mediumDate'}} <span
        *ngIf="!assignment.plan.allDay">{{assignment.plan.executionTime | date:'shortTime'}} til {{endTime |
        date:'shortTime'}}</span>
      <sl-tooltip *ngIf="assignment.notifiedOfImpendingWork" content="Customer has been notified" i18n-content>
        <sl-icon name="chat-text" class="ml-3"></sl-icon>
      </sl-tooltip>
    </sl-label>
    <div class="timestamp__notify">
      <sl-label *ngIf="allowManualNotification && !assignment.notifiedOfImpendingWork" size="x-small" color="blue"
        (click)="onSendNotification()" i18n>Send notification</sl-label>
    </div>

  </div>
  <sl-label 
    size="x-small" 
    color="dark" 
    *ngIf="autoNotificationEnabled && !assignment.notifiedOfImpendingWork" 
    i18n>Customer will be notified in advance</sl-label>
  <sl-label size="small">{{total / 100 | currency:currency}} 
    ({{totalWithTax / 100 | currency:currency}} <span i18n>vat included</span>)
  </sl-label>

  <sl-menu-divider></sl-menu-divider>

  <div class="list">
    <div *ngFor="let task of assignment.tasks" class="mb-2">
      <sl-label size="small">{{task.description}}<sl-icon class="link ml-2" (click)="onReferenceClick(task.reference)"
          *ngIf="task.reference != null" name="box-arrow-up-right"></sl-icon>
      </sl-label>
      <sl-label *ngIf="task.reference != null" size="x-small" color="dark">{{getRecurrenceRule(task.reference) | rrule}}
        <span color="medium" *ngIf="getPreviousDate(task.reference) != null">({{getPreviousDate(task.reference)! |
          timeDistance:assignment.plan.executionTime}})</span></sl-label>
      <sl-label *ngIf="task.reference == null" size="x-small" color="dark">-</sl-label>
    </div>
  </div>

  <ng-container *ngIf="notes?.length ?? 0 > 0 || contact?.note != null">
    <sl-menu-divider></sl-menu-divider>
    <sl-label *ngIf="contact?.note != null" size="small">{{contact?.note}}</sl-label>
    <sl-label size="small" *ngFor="let note of notes">{{note}}</sl-label>
  </ng-container>

  <sl-button class="mt-6 assignment__delete" type="danger" (click)="onDelete()" i18n>Delete assignment</sl-button>

</div>